<template>
  <div class="jupiter-import">
    <v-menu offset-y left :disabled="busy">
      <template #activator="{ on, attrs }">
        <v-btn
          depressed
          outlined
          class="dz-tool"
          :disabled="busy"
          v-bind="attrs"
          v-on="on"
        >
          <v-progress-circular
            v-if="running"
            indeterminate
            size="16"
            width="2"
            class="jupiter-import_spinner"
          />
          <v-icon v-else small left>
            mdi-cloud-download-outline
          </v-icon>
          {{ running ? 'Загрузка из Юпитера…' : 'Юпитер' }}
          <v-icon v-if="!running" small right>
            mdi-chevron-down
          </v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item @click="ask('filials')">
          <v-list-item-title>Загрузить филиалы</v-list-item-title>
        </v-list-item>
        <v-list-item @click="ask('zones')">
          <v-list-item-title>Загрузить зоны из Юпитера</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <primary-confirm-dialog
      v-model="confirm"
      :title="confirmText.title"
      :subtitle="confirmText.sub"
      cancel-text="Назад"
      confirm-text="Загрузить"
      @confirm="start"
    />
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import PrimaryConfirmDialog from '@/components/ui/dialogs/PrimaryConfirmDialog.vue'

  const POLL_MS = 5000
  const KIND_NAMES = { filials: 'филиалов', zones: 'зон', all: 'филиалов и зон' }

  /**
   * Загрузка филиалов и зон из Юпитера (бэк: /geo/delivery-zones/jupiter-import).
   * Импорт идёт в очереди; один за раз на всю сеть, включая ночной крон, - пока он идёт,
   * кнопка заблокирована, статус опрашивается, по окончании - снэкбар и событие finished.
   */
  export default {
    name: 'JupiterImportMenu',
    components: { PrimaryConfirmDialog },
    emits: ['finished'],
    data: () => ({
      confirm: false,
      kind: null,
      starting: false,
      running: null,
      timer: null,
    }),
    computed: {
      busy () {
        return this.starting || !!this.running
      },
      confirmText () {
        if (this.kind === 'filials') {
          return {
            title: 'Загрузить филиалы из Юпитера?',
            sub: 'Данные филиалов, не подключённых к ФАКТ, обновятся из Юпитера.',
          }
        }
        return {
          title: 'Загрузить зоны из Юпитера?',
          sub: 'Зоны Юпитера во всех филиалах перезапишутся, удалённые в Юпитере - удалятся. Зоны, нарисованные в ФАКТ, не затрагиваются.',
        }
      },
    },
    async created () {
      // импорт мог запустить кто-то другой или ночной крон
      try {
        this.apply(await this.fetchJupiterImport())
      } catch (e) {
        // статус не критичен: кнопка останется доступной, бэк сам отклонит повторный запуск
      }
    },
    beforeDestroy () {
      clearTimeout(this.timer)
    },
    methods: {
      ...mapActions('polygons', ['fetchJupiterImport', 'startJupiterImport']),
      ask (kind) {
        this.kind = kind
        this.confirm = true
      },
      async start () {
        this.confirm = false
        this.starting = true
        try {
          this.apply(await this.startJupiterImport(this.kind))
          this.showInfoMessage(`Загрузка ${KIND_NAMES[this.kind]} из Юпитера запущена`)
        } catch (e) {
          const data = e.response && e.response.data
          if (e.response && e.response.status === 409 && data && data.data) {
            this.apply(data.data)
            this.showWarningMessage(`Загрузка ${KIND_NAMES[data.data.running ? data.data.running.kind : this.kind]} из Юпитера уже идёт`)
          } else {
            this.showErrorFromResponse(e)
          }
        } finally {
          this.starting = false
        }
      },
      apply (state) {
        const wasRunning = this.running
        this.running = state.running
        clearTimeout(this.timer)
        if (this.running) {
          this.timer = setTimeout(this.poll, POLL_MS)
        } else if (wasRunning && state.last) {
          this.report(state.last)
        }
      },
      async poll () {
        try {
          this.apply(await this.fetchJupiterImport())
        } catch (e) {
          // сеть моргнула - спросим ещё раз
          this.timer = setTimeout(this.poll, POLL_MS)
        }
      },
      report (last) {
        const what = KIND_NAMES[last.kind] || ''
        if (last.ok) {
          this.showSuccessMessage(`Загрузка ${what} из Юпитера завершена`)
        } else {
          this.showErrorMessage(`Загрузка ${what} из Юпитера не удалась: ${last.error || 'ошибка'}`)
        }
        this.$emit('finished', last)
      },
    },
  }
</script>

<style scoped>
.jupiter-import_spinner {
  margin-right: 8px;
}
</style>
